import { PageLocatorMap } from '../types/PageLocatorMap';

export const applyRefinanceGoalPage = {
  footer: {
    root: 'apply-refinance-goal-page.footer.root',
  },
  form: {
    h1: 'apply-refinance-goal-page.form.h1',
    h2: 'apply-refinance-goal-page.form.h2',
    radioGroupRoot: 'apply-refinance-goal-page.form.radio-group-root',
    radioOption1: 'apply-refinance-goal-page.form.radio-option-1',
    radioOption2: 'apply-refinance-goal-page.form.radio-option-2',
    radioOption3: 'apply-refinance-goal-page.form.radio-option-3',
    root: 'apply-refinance-goal-page.form.root',
    submitButton: 'apply-refinance-goal-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
